import { useState } from 'react';
import { TIERS } from '../constants';
import TierCard from './TierCard';

interface PricingSectionProps {
  onSelectTier: (tierId: string, interval: 'monthly' | 'annual') => void;
}

export default function PricingSection({ onSelectTier }: PricingSectionProps) {
  const [interval, setInterval] = useState<'monthly' | 'annual'>('monthly');

  return (
    <section className="py-10 md:py-14 px-4" id="pricing">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-6 md:mb-10">
          <p className="text-blue-400 text-xs font-semibold tracking-wider uppercase mb-2">
            Pricing
          </p>
          <h2 className="text-xl md:text-3xl font-extrabold mb-2 md:mb-3">
            Three tiers. One goal: independence.
          </h2>
          <p className="text-white/50 text-xs md:text-sm max-w-lg mx-auto mb-5">
            Start with Iron. Upgrade when you're ready. Every tier pays for itself.
          </p>

          {/* Monthly / Annual toggle */}
          <div className="inline-flex items-center gap-1 p-1 rounded-xl bg-white/5 border border-white/10">
            <button
              onClick={() => setInterval('monthly')}
              className={`px-4 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                interval === 'monthly'
                  ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/25'
                  : 'text-white/50 hover:text-white/80'
              }`}
            >
              Monthly
            </button>
            <button
              onClick={() => setInterval('annual')}
              className={`px-4 py-1.5 rounded-lg text-xs font-semibold transition-all flex items-center gap-1.5 ${
                interval === 'annual'
                  ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/25'
                  : 'text-white/50 hover:text-white/80'
              }`}
            >
              Annual
              <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                interval === 'annual' ? 'bg-white/20 text-white' : 'bg-green-500/20 text-green-400'
              }`}>
                2 months free
              </span>
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-3 md:gap-5 items-stretch">
          {TIERS.map((tier) => (
            <TierCard key={tier.id} tier={tier} interval={interval} onSelect={(id) => onSelectTier(id, interval)} />
          ))}
        </div>
      </div>
    </section>
  );
}
